import { PeopleAltOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';
import { getMenuLabel } from '../../global/auth/use-menu-labels/use-menu-labels';

const route = 'volunteering';

export const getGeneralRoutesMap = ({ userIdentityService, configItems, org }: GetRoutesConfig): RoutesMaps => {
  // Default to true if org data is not available yet
  const packageConfig = org?.packageConfig;
  const menuLabels = org?.menuLabels;

  return {
  route,
  heading: 'Volunteering',
  Icon: PeopleAltOutlined,
  isAuthorized: userIdentityService.isVolunteer,
  hidden: packageConfig ? !packageConfig.rostering : false,
  items: [
    {
      ...getMenuLabel('volunteeringActivities', menuLabels),
      route: 'activities',
      isAuthorized: true,
      hidden: packageConfig ? !packageConfig.rostering : false,
    },
    {
      ...getMenuLabel('volunteeringActivityReport', menuLabels),
      route: 'activity-report',
      isAuthorized: configItems.vm.preventVolunteerReports
                   ? (userIdentityService.isActivityLeader ||
                      userIdentityService.isProgramManager ||
                      userIdentityService.isVmAdmin)
                   : true,
      hidden: packageConfig ? !packageConfig.rostering : false,
    },
    {
      ...getMenuLabel('volunteeringIncidentReport', menuLabels),
      route: 'incident-report',
      isAuthorized: true,
      hidden: packageConfig ? !packageConfig.incidents : false,
    },
  ],
  };
};
